import React, { useState } from 'react'
import TabsSimple from '~/Common-Objects/Tabs/TabsSimple'
import PanelHeader from '~/Common-Objects/TemplateEditor/PanelHeader'
import LinkChecker from './linkChecker'
import MergeTagWarnings from './mergeTagChecker'

export default function TemplateChecks({
    templateId,
    templateJson,
    type,
    formLandingPage,
    isFormLandingPage,
    selectElement = () => {}
}) {
    const [selectedTab, setSelectedTab] = useState(0)

    return (
        <>
            <PanelHeader title='Checks' subtitle='Making sure everything is correct' hideBorder={true} />

            <TabsSimple
                tabs={[
                    { label: 'Links', value: 0 },
                    { label: 'Merge Tags', value: 1 }
                ]}
                selectedTab={selectedTab}
                onChange={(tab) => {
                    setSelectedTab(tab)
                }}
                className='mar-b20'
            />

            {selectedTab === 0 && (
                <LinkChecker templateId={templateId} templateJson={templateJson} selectElement={selectElement} />
            )}

            {selectedTab === 1 && (
                <MergeTagWarnings
                    id={templateId}
                    type={type}
                    formLandingPage={formLandingPage}
                    isFormLandingPage={isFormLandingPage}
                    templateJson={templateJson}
                />
            )}
        </>
    )
}
